var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dataLoaded)?_c('Chart',{attrs:{"chartID":"chartID","type":"line","labels":_vm.labels,"datasets":_vm.datasets}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }